import { decompressData } from "@excalidraw/excalidraw/data/encode";
import type { ImportedDataState } from "@excalidraw/excalidraw/data/types";

const BACKEND_GET = import.meta.env.VITE_APP_BACKEND_V2_GET_URL;

export async function loadBoard(id: string, key: string): Promise<ImportedDataState> {
  const res = await fetch(`${BACKEND_GET}${id}`);
  if (!res.ok) {
    throw new Error(`Load failed: HTTP ${res.status}`);
  }
  const buffer = await res.arrayBuffer();
  const { data } = await decompressData(new Uint8Array(buffer), { decryptionKey: key });
  const parsed = JSON.parse(new TextDecoder().decode(data)) as ImportedDataState;
  return {
    elements: parsed.elements ?? null,
    appState: parsed.appState ?? null,
    files: parsed.files ?? undefined,
  };
}
